import React, { useEffect, useState } from 'react';
import { getAllDataPointValues } from "../DataPointValue/DataPointValueClient";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Paper,
    Stack,
    Typography
} from '@mui/material';

const DynamicMultiSelectGridNarrow = ({
                                        clearAll,
                                        selectorDataPointId,
                                        selectorLabel
                                    }) => {
    const [checkboxValues, setCheckboxValues] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);

    const fetchDataPointValues = () =>
        getAllDataPointValues()

            .then(data => {
                setCheckboxValues(
                    data.filter(item => item.dataPointId === selectorDataPointId)
                );
            });

    useEffect(() => {
        fetchDataPointValues();
    }, [selectorDataPointId]);

    useEffect(() => {
        setSelectedValues([]);
    }, [clearAll]);

    const handleToggle = (valueName) => {
        setSelectedValues(prev =>
            prev.includes(valueName)
                ? prev.filter(item => item !== valueName)
                : [...prev, valueName]
        );
    };

    const handleSelectAll = () => {
        setSelectedValues(checkboxValues.map(value => value.name));
    };

    const handleClearAll = () => {
        setSelectedValues([]);
    };

    return (
        <FormControl sx={{ width: 300 }}>
            <Typography sx={{ fontWeight: 600 }}>
                {selectorLabel}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>


                <Button size="small" onClick={handleSelectAll}>
                    Select All
                </Button>

                <Button size="small" onClick={handleClearAll}>
                    Clear All
                </Button>
            </Stack>

            <Paper
                variant="outlined"
                sx={{
                    p: 1,
                    maxHeight: 500,
                    overflowY: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        // gridTemplateColumns: 'repeat(4, 1fr)',
                        // columnGap: 2,
                        // rowGap: 0
                    }}
                >
                    {checkboxValues.map((value) => (
                        <FormControlLabel
                            key={value.id}
                            sx={{
                                m: 0,
                                height: 28,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: 13
                                }
                            }}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={selectedValues.includes(value.name)}
                                    onChange={() => handleToggle(value.name)}
                                    sx={{ py: 0.25 }}
                                />
                            }
                            label={value.name}
                        />
                    ))}
                </Box>
            </Paper>
        </FormControl>
    );
};

export default DynamicMultiSelectGridNarrow;